import { isArray } from "lodash-es";

import { BTLoginTypes } from "types/enum";

import { type IMentionableUser } from "commonComponents/entity/comment/CommentContainer/CommentContainer.api.types";

export interface IHasContent {
    type: string;
    attrs?: { id: number };
    content?: IHasContent;
}

export function scanForMentions(
    mentionableUsers: IMentionableUser[],
    node: IHasContent,
    ids: number[],
): number[] {
    if (!node) {
        return ids;
    }
    if (node.type === "mentionUser" && node.attrs?.id) {
        if (node.attrs?.id === -1) {
            // @everyone
            return [...ids, ...mentionableUsers.map((u) => u.id)];
        }
        return [...ids, node.attrs.id];
    }
    if (node.content) {
        if (isArray(node.content)) {
            return [
                ...ids,
                ...node.content.flatMap((n) => scanForMentions(mentionableUsers, n, ids)),
            ];
        }
        return [...ids, ...scanForMentions(mentionableUsers, node.content, ids)];
    }
    return ids;
}

export type CommentTabNames = "internal" | "subs" | "clients";

export function includeUser(tab: CommentTabNames, user: { type?: number }) {
    return (
        user.type === BTLoginTypes.BUILDER ||
        (tab === "subs" && user.type === BTLoginTypes.SUBS) ||
        (tab === "clients" && user.type === BTLoginTypes.OWNER) ||
        (tab === "clients" && user.type === BTLoginTypes.CONTACT)
    );
}
